import React,{useState, useEffect} from "react";

import {Carousel} from 'react-bootstrap'

export default function ControlledCarousel(props) {
  const [index, setIndex] = useState(0);
  const [slides,setSlides]=useState([]);

  useEffect(() => {
   const data= props.data;
   const images=[
       {image:data.sliderImage1,title:data.sliderText1,subTitle:data.slidersubText1},
       {image:data.sliderImage2,title:data.sliderText2,subTitle:data.slidersubText2},
       {image:data.sliderImage3,title:data.sliderText3,subTitle:data.slidersubText3}
   ]
   setSlides(images);
  },[props]);
  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
  };

  return (
    <Carousel activeIndex={index} onSelect={handleSelect}>
        {slides && slides.length > 0 && slides.map(s=>{
            return (
                <Carousel.Item>
                <img
                  className="d-block w-100"
                  src={s.image}
                  alt="First slide"
                />
                <Carousel.Caption>
                  <h3>{s.title}</h3>
                  <p>{s.subTitle}</p>
                </Carousel.Caption>
              </Carousel.Item>
            )
        })}
      
     </Carousel>
  );
}

